import { createFileRoute } from '@tanstack/react-router'
import ChatBox from '@/components/chat-route/chat-box/index.jsx'

export const Route = createFileRoute('/_auth/chat/$ticketId')({
  component: ChatBoxWrapper,
})

function ChatBoxWrapper() {
  const { ticketId } = Route.useParams()
  return <ChatBox ticketId={ticketId} />
}
